import { Injectable } from '@angular/core';
import { LiteratureDataService } from '@literature/services/literature-data.service';
import { AppStateService, LiteratureFlow } from '@services/app-state.service';
import { IUserProfile, IUserProfileInfo } from '@services/profile.interface';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import {
  OrderHistoryDocument,
  OrderHistoryDetail,
  LiteratureRequestBodyProfile,
} from '@types';
import { LiteratureGlobalConfigService } from '@literature/services/literature-global-config.service';
import { LiteratureApiService } from '@literature/services/api-services/literature-api.service';

@Injectable({
  providedIn: 'root',
})
export class LiteratureOrderHistoryDetailService {
  constructor(
    private appStateService: AppStateService,
    private literatureDataService: LiteratureDataService,
    private literatureConfig: LiteratureGlobalConfigService,
    private literatureApiService: LiteratureApiService
  ) {}
  /**
   * Populates order history details
   * @param profileInfo IUserProfileInfo
   * @param orderNumber Order Number
   * @returns OrderHistoryDetail
   */
  populate(
    profileInfo: IUserProfileInfo,
    orderNumber: string
  ): Observable<OrderHistoryDetail> {
    const profile = this.literatureDataService.literatureUserProfileMapper(
      profileInfo
    );
    return this.getOrderHistoryDetail(profile, orderNumber).pipe(
      map((data: OrderHistoryDetail) => {
        this.addItemDetailLink(data.document);
        return data;
      }),
      shareReplay(1)
    );
  }

  addItemDetailLink(data: OrderHistoryDocument[]): OrderHistoryDocument[] {
    return data.map((element) => {
      element.itemDetailLink = this.getItemDetailLink(element.literatureCode);
      return element;
    });
  }

  getItemDetailLink(literatureCode: string): string {
    return `${this.literatureConfig?.navigationUrls?.litDetailUrl}/${literatureCode}`;
  }

  getUrl(expressNo: string, orderNumber: string): string {
    // ToDo: get express number from profile
    return (
      this.appStateService.getLiteratureOrderHistoryListUrl() +
      `/${expressNo}/` +
      orderNumber
    );
  }

  getAPIMFlowUrl(userSysNo: string, orderNumber: string): string {
    return (
      this.appStateService.getOrderHistoryDetailAPIMUrl() +
      `${userSysNo}/` +
      orderNumber
    );
  }

  getOrderHistoryDetail(
    profileInfo: LiteratureRequestBodyProfile,
    orderNumber: string
  ): Observable<OrderHistoryDetail> {
    if (this.appStateService.getuseAPIM(LiteratureFlow.ORDER_HISTORY_DETAIL)) {
      return this.literatureApiService.getOrderHistoryDetailAPIMFlow(
        this.getAPIMFlowUrl(profileInfo?.userSysNo, orderNumber),
        profileInfo
      );
    } else {
      return this.literatureApiService.getOrderHistoryDetail(
        this.getUrl(profileInfo?.businessKey, orderNumber),
        profileInfo
      );
    }
  }

  getProfileData$(): Observable<IUserProfile> {
    return this.literatureDataService.getProfileData$();
  }
}
